import { useAccountPortalStore } from '@/stores/account-portal'
import { useAppStore } from '@/stores/app'
import { useAsmStore } from '@/stores/asm'
import { useCartStore } from '@/stores/cart'
import { useCartFlowStore } from '@/stores/cart-flow'
import { usePunchoutStore } from '@/stores/punchout'
import { useRolesStore } from '@/stores/roles'
import { useSessionStore } from '@/stores/session'

export function migrateVuexToPinia() {
  try {
    const vuexData = window.localStorage?.getItem('vuex')

    if (!vuexData) {
      return false
    }

    const vuexState = JSON.parse(vuexData)

    const sessionStore = useSessionStore()
    const cartStore = useCartStore()
    const asmStore = useAsmStore()
    const punchoutStore = usePunchoutStore()
    const cartFlowStore = useCartFlowStore()
    const rolesStore = useRolesStore()
    const appStore = useAppStore()
    const accountPortalStore = useAccountPortalStore()

    if (vuexState.session) {
      sessionStore.$patch(vuexState.session)
    }

    if (vuexState.cart) {
      cartStore.$patch(vuexState.cart)
    }

    if (vuexState.asm) {
      asmStore.$patch(vuexState.asm)
    }

    if (vuexState.punchout) {
      punchoutStore.$patch(vuexState.punchout)
    }

    if (vuexState.cartFlow) {
      cartFlowStore.$patch(vuexState.cartFlow)
    }

    if (vuexState.roles) {
      rolesStore.$patch(vuexState.roles)
    }

    if (vuexState.app) {
      appStore.$patch(vuexState.app)
    }

    if (vuexState['account-portal']) {
      accountPortalStore.$patch(vuexState['account-portal'])
    }

    window.localStorage.setItem('piniaMigratedFromVuex', 'true')
    window.localStorage.removeItem('vuex')

    return true
  } catch (error) {
    console.error('Error migrating Vuex data to Pinia:', error)
    return false
  }
}

export function checkAndMigrateVuexData() {
  if (window.localStorage?.getItem('piniaMigratedFromVuex') === 'true') {
    return false
  }

  return migrateVuexToPinia()
}
